// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__huCJv","additionalInfo":"AgreementModal_additionalInfo__SuG3f"};